import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const chartOptions = {
  responsive: true,
  indexAxis: 'y',
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  scales: {
    x: {
      stacked: true,
      grid: {
        display: false,
      },
      display: false,
    },
    y: {
      stacked: true,
      grid: {
        display: false,
      },
      display: false,
    },
  },
};

export default {
  name: 'HorizontalBarChart',
  components: {
    Bar,
  },
  props: {
    collection: {
      type: Object,
      default: () => ({}),
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mergedOptions() {
      return {
        ...chartOptions,
        ...this.chartOptions,
      };
    },
  },
  template: '<Bar :data=\"collection\" :options=\"mergedOptions\" />',
};
